var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserProfilesmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65 3.65A2.64 2.64 0 0 1 6 6.29a2.64 2.64 0 0 1-2.65-2.64A2.64 2.64 0 0 1 6 1a2.64 2.64 0 0 1 2.65 2.65ZM6 11c-2.17 0-4-.35-4-1.71 0-1.36 1.84-1.7 4-1.7 2.17 0 4 .35 4 1.7C10 10.67 8.16 11 6 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfilesmall);
export default __webpack_public_path__ + "static/media/userProfile.small.314b96ed64b722e48e3d8e123f28f37a.svg";
export { ForwardRef as ReactComponent };